import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Chat, SendStatusEnum, ActivityStatusEnum } from '@matap/shared';
import { SocketStateEnum } from '@/constants';

const reducer = createSlice({
  name: 'chat.reducer',
  initialState: {
    chats: [] as Chat[],
    remoteActivityStatus: ActivityStatusEnum.IDLE,
    socketState: SocketStateEnum.INITIAL,
    activityStatusExpirationTimerId: undefined as any,
  },
  reducers: {
    actionAddNewChatMessage(state, action: PayloadAction<Chat>) {
      state.chats.unshift(action.payload);
      state.remoteActivityStatus = ActivityStatusEnum.IDLE;
      clearTimeout(state.activityStatusExpirationTimerId);
    },
    actionSetRemoteActivityStatus(state, action: PayloadAction<{ status: ActivityStatusEnum; timer?: any }>) {
      state.remoteActivityStatus = action.payload.status;
      if (state.activityStatusExpirationTimerId) {
        clearTimeout(state.activityStatusExpirationTimerId);
      }
      state.activityStatusExpirationTimerId = action.payload.timer;
    },
    actionSetConversations(state, action: PayloadAction<{ chats: Chat[]; userId: string }>) {
      const serverArray = [...action.payload.chats].reverse().map((chat) => {
        const current = state.chats.find((s) => s._id === chat._id);
        return current || chat;
      });
      const serverIds = new Set(action.payload.chats.map((c) => c._id));
      const localUnsent = state.chats.filter(
        (c) => c.senderId === action.payload.userId && [SendStatusEnum.SENDING, SendStatusEnum.FAILED].includes(c.sendStatus) && !serverIds.has(c._id),
      );
      state.chats = [...localUnsent, ...serverArray].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    },
    actionUpdateChat(state, action: PayloadAction<Partial<Chat & { _id: string }>>) {
      const chat = state.chats.find((s) => s._id === action.payload._id);
      if (chat) {
        if (chat.sendStatus === SendStatusEnum.DELIVERED && action.payload.sendStatus === SendStatusEnum.SENT) {
          action.payload.sendStatus = SendStatusEnum.DELIVERED;
        }
        Object.assign(chat, action.payload);
      }
    },
    actionDeleteChat(state, action: PayloadAction<string>) {
      const chat = state.chats.find((s) => s._id === action.payload);
      if (!chat) {
        return;
      }

      state.chats.splice(state.chats.indexOf(chat), 1);
    },
    actionSetSocketState(state, action: PayloadAction<SocketStateEnum>) {
      state.socketState = action.payload;
    },
  },
});

export const { actionAddNewChatMessage, actionSetSocketState, actionSetRemoteActivityStatus, actionSetConversations, actionUpdateChat, actionDeleteChat } =
  reducer.actions;
export default reducer.reducer;
